module.exports = __webpack_public_path__ + "img/jdcreative.71385e29.jpg";